import { Estimate } from 'types/estimate'
import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface EstimateStore {
  estimate: Estimate | null;
  setEstimate: ( estimate: Estimate | null ) => void;
  estimateError: boolean;
  setEstimateError: ( error: boolean ) => void;
}

export const useEstimateStore = create<EstimateStore>()(
  persist(
    ( set ) => ({
      estimate: null,
      estimateError: false,
      setEstimateError: ( error: boolean ) => set({
        estimateError: error
      }),
      setEstimate: ( estimate: any ) => set({
        estimate
      })
    }),
    {
      name: `resupply-estimate-storage`,
      storage: createJSONStorage( () => sessionStorage ),
      skipHydration: true
    }
  )
)
